import React from 'react';
import PropTypes from 'prop-types';

import styles from './productPurchaseCard/ProductPurchaseCard.m.sass';

import FieldCheckbox from '../fields/fieldCheckbox/FieldCheckbox';
import Pricing from '../pricing/Pricing';

export function calculateOption(basePrice, quantity, option) {
  if (option.quantityIndependent) {
    quantity = 1;
  }

  switch (option.pricing.operation) {
    case '*':
      return basePrice * quantity * parseFloat(option.pricing.modifier);
    case '+':
      return parseFloat(option.pricing.price) * quantity;
    default:
      return 0;
  }
}

export function applyOptions(basePrice, quantity, options) {
  return options
    .map(option => calculateOption(basePrice, quantity, option))
    .reduce((acc, delta) => acc + delta, basePrice * quantity);
}

function OptionValue({operation, priceDelta}) {
  switch (operation) {
    case '+':
    case '*':
      return priceDelta !== 0 && (
        <Pricing
          small
          annotation={priceDelta > 0 ? '+' : '-'}
          value={Math.abs(priceDelta)}
        />
      );
    default:
      return false;
  }
}

export default function ProductOptionsPicker({basePrice, quantity, availableOptions, selectedOptionIds, onChange}) {
  return availableOptions
        .filter(it => ProductOptionsPicker.supportedOperations.includes(it.pricing.operation))
        .map(it => ({...it, priceDelta: calculateOption(basePrice, quantity, it)}))
        .sort((a, b) => a.position - b.position)
        .map(option => (
          <FieldCheckbox
            key={option.id}
            input={{
              checked: selectedOptionIds.includes(option.id),
              onChange: evt => onChange(
                evt.target.checked ?
                  selectedOptionIds.concat(option.id)
                  : selectedOptionIds.filter(it => it !== option.id)
              )
            }}
          >
            <span className={styles.productCard_optionText}>{option.name}</span>

            <OptionValue
              operation={option.pricing.operation}
              priceDelta={option.priceDelta}
              modifier={option.pricing.modifier}
            />
          </FieldCheckbox>
        ));
}

ProductOptionsPicker.propTypes = {
  basePrice: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  availableOptions: PropTypes.array.isRequired,
  selectedOptionIds: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  row: PropTypes.bool
};


ProductOptionsPicker.supportedOperations = ['+', '*'];



// WEBPACK FOOTER //
// ./components/productPurchase/ProductOptionsPicker.js